import { render, staticRenderFns } from "./NodeItem.vue?vue&type=template&id=c55e1358&scoped=true"
import script from "./NodeItem.vue?vue&type=script&lang=js"
export * from "./NodeItem.vue?vue&type=script&lang=js"
import style0 from "./NodeItem.vue?vue&type=style&index=0&id=c55e1358&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55e1358",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c55e1358')) {
      api.createRecord('c55e1358', component.options)
    } else {
      api.reload('c55e1358', component.options)
    }
    module.hot.accept("./NodeItem.vue?vue&type=template&id=c55e1358&scoped=true", function () {
      api.rerender('c55e1358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/add/union/NodeItem.vue"
export default component.exports